import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import TopService from "../../services/topService";
import CollectorCard from "../CollectorCard/CollectorCard";
import LinkWrapper from "../LinkWrapper/LinkWrapper";
import { TopUser } from "../../types/authTypes";

enum TIME_FILTER {
  WEEK = "week",
  ALL = "all",
}

const TopCollectors = () => {
  const [selectedTime, setSelectedTime] = useState<TIME_FILTER>(
    TIME_FILTER.ALL
  );
  const [collectors, setCollectors] = useState<Array<TopUser> | undefined>(
    undefined
  );

  const { getTopUsersByNumber } = TopService();

  const handleTimeChange = (newValue: TIME_FILTER) => {
    setSelectedTime(newValue);
  };

  useEffect(() => {
    if (selectedTime === TIME_FILTER.ALL) {
      getTopUsersByNumber(3, 1).then((result) => {
        if (result) {
          setCollectors(result.data as Array<TopUser>);
        }
      });
    } else {
      const today = dayjs();
      const oneWeekAgo = today.subtract(1, "week");
      const formattedToday = today.format("YYYY/MM/DD");
      const formattedOneWeekAgo = oneWeekAgo.format("YYYY/MM/DD");
      getTopUsersByNumber(3, 1, formattedOneWeekAgo, formattedToday).then(
        (result) => {
          if (result) {
            setCollectors(result.data as Array<TopUser>);
          }
        }
      );
    }
  }, [selectedTime]);

  return (
    <Box sx={{ marginTop: { xs: "2rem", md: "3rem" } }}>
      <Box
        sx={{
          width: "100%",
          display: { xs: "block", sm: "flex" },
          justifyContent: "space-between",
          alignItems: "center",
          borderTop: "1px solid #eee",
          borderBottom: "1px solid #eee",
          padding: "1rem 0px",
        }}
      >
        <Box sx={{ marginBottom: { xs: "1rem", sm: "0rem" } }}>
          <Typography
            variant="communitySectionTitle"
            sx={{ fontStyle: "italic" }}
          >
            Top Collectors
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            columnGap: "10px",
          }}
        >
          <Box>
            <Button
              disabled={selectedTime === TIME_FILTER.ALL}
              variant={
                selectedTime === TIME_FILTER.ALL
                  ? "secondarySelected"
                  : "secondary"
              }
              onClick={() => handleTimeChange(TIME_FILTER.ALL)}
              sx={{ fontStyle: "italic" }}
            >
              All-time
            </Button>
          </Box>
          <Box>
            <Button
              disabled={selectedTime === TIME_FILTER.WEEK}
              variant={
                selectedTime === TIME_FILTER.WEEK
                  ? "secondarySelected"
                  : "secondary"
              }
              onClick={() => handleTimeChange(TIME_FILTER.WEEK)}
              sx={{ fontStyle: "italic" }}
            >
              Last 7 days
            </Button>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: { xs: "block", sm: "flex" },
          justifyContent: "center",
          padding: "1.5rem 0rem",
        }}
      >
        {collectors ? (
          collectors.map((item, index) => (
            <Box key={index} sx={{ width: { xs: "100%", md: "33%" } }}>
              <CollectorCard key={item.id} data={item} count={index} />
            </Box>
          ))
        ) : (
          <CircularProgress />
        )}
      </Box>

      <Box sx={{ textAlign: "center" }}>
        <LinkWrapper
          visitorUrl="/sign-up"
          freeUserUrl="/search-for-collectors"
          premiumUserUrl="/search-for-collectors"
          component={
            <a className="default-btn move-right">
              <span style={{ fontStyle: "italic" }}>All Collectors</span>
            </a>
          }
        />
      </Box>
    </Box>
  );
};

export default TopCollectors;
